module.exports = __webpack_public_path__ + "media/images/icons/heart-bold-ec1f3432884e6f1af6ddf2e52b9a3e3a.svg";